import { render, staticRenderFns } from "./HomeCms.vue?vue&type=template&id=081aafe3&scoped=true&"
import script from "./HomeCms.vue?vue&type=script&lang=js&"
export * from "./HomeCms.vue?vue&type=script&lang=js&"
import style0 from "./HomeCms.vue?vue&type=style&index=0&id=081aafe3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081aafe3",
  null
  
)

export default component.exports